exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.banner-testing-mode {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tleft: 0;\n\theight: 3px;\n\tbackground-color: #f66;\n}\n.container-testing-mode {\n\tposition: absolute;\n\ttop: 3px;\n\tright: 0;\n\tpadding: 15px;\n\tbackground-color: #f66;\n\tcolor: white;\n\tfont-size: 13px;\n\tfont-weight: bolder;\n\tborder-radius: 0px 0px 0px 15px;\n}\n", ""]);

// exports
